import { loadOnInteraction } from "./includes/utils.js";
import bcCategoryNav from "./includes/navigation";
import cf7Init from "./libs/cf7";
import footerCatAccordion from "./includes/footer";
import googleInit from "./libs/google";
import header from "./includes/header";
import newsHero from "./includes/news";
import selectInit from "./libs/select/index.js";
import sidebarEvents from "./includes/sidebar-events";
import { lazyload } from "./modules/lazyload";
import { liveBlogPopout } from "./includes/live-blog-popout";

loadOnInteraction({
  callback: () => {
    // Google GA4
    googleInit();
    // Contact Form 7
    cf7Init();
    liveBlogPopout();
  },
});
// Header | Mobile Menu
bcCategoryNav();
// Footer | Accordion
footerCatAccordion();
// News Single | Hero
newsHero();
// Close Search | Header
header();
// Hide Sidebar Events Title if there are no posts
sidebarEvents();
// Select Box
selectInit();
// Lazyload
lazyload();
